import API from './api';

export const getPlatformOverview = ({ signal } = {}) =>
  API.get('/auth/platform_admin/', { signal }).then((response) => response.data);

export const getPlatformOrganizations = ({ search = '', signal } = {}) =>
  API.get('/auth/platform_admin/organizations/', {
    signal,
    params: search ? { search } : undefined,
  }).then((response) => response.data);

export const getPlatformOrganization = (uuid) =>
  API.get(`/auth/platform_admin/organizations/${uuid}/`).then((response) => response.data);

export const createPlatformOrganization = (payload) =>
  API.post('/auth/platform_admin/organizations/', payload).then((response) => response.data);

export const setPlatformOrganizationState = (uuid, payload) =>
  API.patch(`/auth/platform_admin/organizations/${uuid}/state/`, payload).then(
    (response) => response.data,
  );

export const setPlatformOrganizationService = (uuid, payload) =>
  API.put(`/auth/platform_admin/organizations/${uuid}/service-access/`, payload).then(
    (response) => response.data,
  );

export const getPlatformUsers = ({ search = '', organization = '', signal } = {}) =>
  API.get('/auth/platform_admin/users/', {
    signal,
    params: {
      ...(search && { search }),
      ...(organization && { organization }),
    },
  }).then((response) => response.data);

export const createPlatformUser = (payload) =>
  API.post('/auth/platform_admin/users/', payload).then((response) => response.data);

export const updatePlatformUserAccount = (uuid, payload) =>
  API.patch(`/auth/platform_admin/users/${uuid}/account/`, payload).then(
    (response) => response.data,
  );

export const resendPlatformUserInvitation = (uuid) =>
  API.post(`/auth/platform_admin/users/${uuid}/resend-invitation/`).then(
    (response) => response.data,
  );

export const sendPlatformUserPasswordReset = (uuid) =>
  API.post(`/auth/platform_admin/users/${uuid}/send-password-reset/`).then(
    (response) => response.data,
  );

export const acceptPlatformAccountInvitation = (token, password) =>
  API.post(`/auth/platform_account_invitation/${token}/`, { password }).then(
    (response) => response.data,
  );

export const setPlatformUserState = (uuid, payload) =>
  API.patch(`/auth/platform_admin/users/${uuid}/state/`, payload).then(
    (response) => response.data,
  );

export const setPlatformUserService = (uuid, payload) =>
  API.put(`/auth/platform_admin/users/${uuid}/service-access/`, payload).then(
    (response) => response.data,
  );

export const testPlatformProvider = (provider) =>
  API.post('/auth/platform_admin/providers/', { provider }).then((response) => response.data);
